import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useGlobalState } from "../context/GlobalStateContext";
import "./CharacterBackground.css";

function CharacterBackground({
  backToList,
  createNewCharacter,
  editCharacter,
}) {
  const { sessionInfo, setSessionInfo, audioStreaming } = useGlobalState();
  const [isMaster, setIsMaster] = useState(false);
  const [isGennaro, setIsGennaro] = useState(false);
  const [sound, setSound] = useState(null);
  const [currentVolume, setCurrentVolume] = useState(
    localStorage.getItem("masterVolume") || 50,
  );
  const [isMuted, setIsMuted] = useState(false);
  const audioRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    setIsMaster(sessionInfo.user?.isMaster || false);
    setIsGennaro(sessionInfo.user?.username === "gennaro");
  }, [sessionInfo]);

  // Audio player logic
  useEffect(() => {
    if (audioStreaming) {
      if (sound?._id !== audioStreaming._id) {
        setSound(audioStreaming);
      }
    } else {
      setSound(null);
    }
  }, [audioStreaming, sound]);

  useEffect(() => {
    if (sound && audioRef.current) {
      audioRef.current.src = sound.filePath;
    }
  }, [sound]);

  useEffect(() => {
    if (audioRef.current) {
      localStorage.setItem("masterVolume", currentVolume);
      audioRef.current.volume = isMuted ? 0 : currentVolume / 100;
    }
  }, [currentVolume, isMuted]);

  const toggleMute = () => {
    setIsMuted(!isMuted);
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    setSessionInfo({
      ...sessionInfo,
      user: null,
      characters: null,
      activeCharacter: null,
    });
    navigate("/login");
  };

  const handleGotoList = () => {
    setSessionInfo({ ...sessionInfo, activeCharacter: null });
    navigate("/characters/list");
  };

  const handleGotoCreateNewCharacter = () => {
    setSessionInfo({ ...sessionInfo, activeCharacter: null });
    navigate("/characters/new");
  };

  const handleGotoEditCharacter = (id) => {
    navigate(`/characters/edit/${id}`);
  };

  const handleGotoAudio = (id) => {
    navigate(`/audio`);
  };

  const handleGotoAdmin = () => {
    navigate(`/admin`);
  };

  return (
    <div className="character-background">
      <div className="character-background_header"></div>
      <div className="character-background_buttons">
        <div className="page-content">
          <div className="character-background_nav-buttons">
            <div>
              <button onClick={() => handleLogout()}>Torna al Login</button>
            </div>
            {isMaster && (
              <div>
                <button onClick={() => handleGotoAudio()}>Vai a Audio</button>
              </div>
            )}
            {isGennaro && (
              <div>
                <button onClick={() => handleGotoAdmin()} className="admin-btn">
                  ⚙️ Admin
                </button>
              </div>
            )}
            {backToList && (
              <div>
                <button onClick={() => handleGotoList()}>Vai a Lista</button>
              </div>
            )}
            {createNewCharacter && (
              <div>
                <button onClick={() => handleGotoCreateNewCharacter()}>
                  Crea Nuovo
                </button>
              </div>
            )}
            {editCharacter && (
              <div>
                <button
                  onClick={() => handleGotoEditCharacter(editCharacter._id)}
                >
                  Modifica
                </button>
              </div>
            )}
          </div>

          {sound && (
            <div className="character-background_audio-controls">
              <audio ref={audioRef} hidden loop autoPlay={true}>
                <source src={sound.filePath} type="audio/mpeg" />
              </audio>
              <button
                onClick={toggleMute}
                className={`audio-mute-btn ${isMuted ? "muted" : ""}`}
                title={isMuted ? "Unmute" : "Mute"}
              >
                {isMuted ? "🔇" : "🔊"}
              </button>
              <input
                type="range"
                min="0"
                max="100"
                value={currentVolume}
                onChange={(e) => setCurrentVolume(e.target.value)}
                className="audio-volume-slider"
                title={`Volume: ${currentVolume}%`}
              />
              <span className="audio-volume-label">{currentVolume}%</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default CharacterBackground;
